













































import { Component, Vue } from 'vue-property-decorator';
import { Routes } from '../router';

@Component
export default class Home extends Vue {
	private url = '';

	private textRank = false;

	private rake = false;

	get disabled() {
		return !(this.rake || this.textRank) || this.url.length === 0;
	}

	summarize() {
		console.log(this.url, this.textRank, this.rake);
		this.$router.push({
			path: Routes.Result,
			query: {
				url: this.url,
				textRank: this.textRank ? '1' : '0',
				rake: this.rake ? '1' : '0',
			},
		});
	}
}
